<section class="container-fluid">
  <div class="d-flex justify-content-between align-items-center py-1 mb-1 border-bottom">
    <div class="d-flex justify-content-between align-items-center">
      <label class="mx-1">
        <input type="search" placeholder="جستجو" class="fs-sm" [(ngModel)]="keyword"/>
      </label>
      <label class="mx-1">
        <select [(ngModel)]="disabled" class="fs-sm">
          <option [ngValue]="null">مهم نیست</option>
          <option [ngValue]="false">فعال</option>
          <option [ngValue]="true">غیرفعال</option>
        </select>
      </label>
      <div class="mx-1">
        <button class="btn btn-secondary btn-sm" (click)="load()">دریافت</button>
      </div>
    </div>
    <div>
      <app-pagination class="mx-auto" [total]="total" [limit]="limit" (page)="load($event.from)"></app-pagination>
    </div>
    <button class="btn btn-primary btn-sm" (click)="open()">افزودن تخفیف</button>

  </div>

  <div class="col-12 relative" style="min-height: 400px;">
    <ngx-spinner name="action" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
    <section class="container-fluid">
      <div class="row fs-normal sticky  dark-gray-bg f-yellow text-center">
        <div class="col">عنوان</div>
        <div class="col-1">نوع</div>
        <div class="col-1">کد تخفیف</div>
        <div class="col-1">درصد تخفیف</div>
        <div class="col-1">تاریخ شروع</div>
        <div class="col-1">تاریخ انقضا</div>
        <div class="col-1">تعداد باقیمانده</div>
        <div class="col-2">Regex</div>
        <div class="col-1">استفاده شده</div>
        <div class="col-1">عملیات</div>
      </div>
      <div class="row border-bottom light-yellow-bg-hover" [class.f-gray]="discount.Disabled" *ngFor="let discount of discounts;let i=index">
        <div class="col">{{discount.Title}}</div>
        <div class="col-1">{{discount.Type}}</div>
        <div class="col-1">{{discount.Code}}</div>
        <div class="col-1">{{discount.Percentage/100|percent}}</div>
        <div class="col-1">{{discount.StartTime|pdate}}</div>
        <div class="col-1">{{discount.ExpirationTime|pdate}}</div>
        <div class="col-1">{{discount.Remaining|number}}</div>
        <div class="col-2">{{discount.UsernameRegex}}</div>
        <div class="col-1">{{discount.Usages?.length||0}}</div>
        <div class="col-1 d-flex justify-content-between py-1">
          <i class="fa fa-edit fs-lg ml-1 pointer" (click)="open(discount)"></i>
          <i class="fa fa-trash fs-lg ml-1 pointer" (confirm)="delete(discount.Id)"></i>
        </div>
      </div>
    </section>
  </div>
</section>

<ngx-smart-modal #discountModal identifier="discountModal">
  <ngx-spinner name="action" [fullScreen]="false" type="timer"></ngx-spinner>
  <div class="container mt-5">
    <div class="row">
      <div class="col-4 form-group">
        <h6>عنوان</h6>
        <input type="text" name="title" placeholder="عنوان" [(ngModel)]="selected.Title">
      </div>
      <div class="col-4 form-group">
        <h6>نوع</h6>
        <select [(ngModel)]="selected.Type">
          <option value=""></option>
          <option value="postad">آگهی</option>
          <option value="vanguard-seeker">کارجوی پیشتاز</option>
          <option value="buy-resume">خرید رزومه</option>
        </select>
      </div>
      <div class="col-4 form-group">
        <h6>منبع</h6>
        <input type="text" name="source" placeholder="منبع" [(ngModel)]="selected.Source">
      </div>
      <div class="col-6 form-group">
        <h6>کد تخفیف</h6>
        <input type="text" dir="ltr" name="code" [(ngModel)]="selected.Code"
          placeholder="جهت ایجاد اتوماتیک کد این فیلد را خالی بگذارید">
      </div>
      <div class="col-6 form-group">
        <h6>درصد تخفیف</h6>
        <input type="number" inputmode="numeric" pattern="\d*" dir="ltr" name="percentage" placeholder="درصد تخفیف" min="0" max="100"
          [(ngModel)]="selected.Percentage">
      </div>
      <div class="col-6 form-group">
        <h6>پترن موبایل</h6>
        <input type="text" dir="ltr" name="regex" placeholder="Regex" [(ngModel)]="selected.UsernameRegex">
      </div>
      <div class="col-6 form-group">
        <h6>تعداد استفاده</h6>
        <input type="number" inputmode="numeric" pattern="\d*" dir="ltr" name="remaining" placeholder="تعداد استفاده" [(ngModel)]="selected.Remaining">
      </div>
      <div class="col-6 form-group">
        <h6>تاریخ شروع</h6>
        <app-calendar name="start-time" [(ngModel)]="selected.StartTime"></app-calendar>
      </div>
      <div class="col-6 form-group">
        <h6>تاریخ انقضا</h6>
        <app-calendar name="expiration-time" [(ngModel)]="selected.ExpirationTime"></app-calendar>
      </div>
      <div class="col-6 form-group">
        <label>
          <input type="checkbox" name="disabled" [(ngModel)]="selected.Disabled">
          غیرفعال
        </label>
      </div>
    </div>
    <div class="btn-group text-left">
      <button class="btn btn-yellow" type="submit" (click)="save()">ذخیره</button>
    </div>
  </div>
</ngx-smart-modal>